"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7635],{

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 21867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5779);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);





const Card = (param)=>{
    let { children , className , onClick , imgSrc ="" , imgWidth =80 , imgHeight =80 , title ="Card" , selected =false , text , fixedWidth =true , ratio ="aspect-square" , disabled =false , show =true  } = param;
    const { theme , StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
        className: "flex flex-col items-center text-center px-5 py-5 rounded-md ".concat(className, " ").concat(onClick && !disabled ? "cursor-pointer" : "cursor-not-allowed"),
        style: {
            backgroundColor: disabled ? StaticColours.disabled : selected ? StaticColours.v2.light_blue : theme.foregroundColour,
            ...fixedWidth ? {
                width: "320px"
            } : {}
        },
        onClick: disabled ? undefined : onClick,
        children: [
            title !== "Card" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "text-xl mt-1 mb-5",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!imgSrc,
                className: "flex items-center rounded-md bg-white ".concat(fixedWidth ? "w-full" : "", " h-auto ").concat(ratio),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    className: "w-full h-full ".concat(disabled && "saturate-0"),
                    style: {
                        objectFit: "fill"
                    },
                    src: imgSrc,
                    alt: title,
                    width: imgWidth,
                    height: imgHeight
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!text,
                className: "text-xs break-words pt-4 px-4",
                style: {
                    width: "18rem"
                },
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!children,
                className: "mt-6 text-xl size-full",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 84456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PriceInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6686);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5779);





/**
 * Primary UI component for text input
 */ const PriceInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , currencySymbol ="\xa3" , labelBgColour , textColour , border ="border" , maxValue  } = param;
    const { theme , StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(value, validations);
    const [hintColor, setHintColor] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(theme.textColour);
    const [dynamicClasses, setDynamicClasses] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [timer, setTimer] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const input = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "relative flex items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute ml-4 text-sm",
                children: currencySymbol
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                required: required,
                value: value,
                onChange: (e)=>{
                    let val = e.target.value;
                    const isInvalid = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(e.target.value, validations) !== "";
                    if (maxValue && parseInt(e.target.value) > maxValue) {
                        e.target.value = maxValue === null || maxValue === void 0 ? void 0 : maxValue.toString();
                        if (!timer) {
                            const timeout = setTimeout(()=>{
                                setHintColor(theme.textColour);
                                setDynamicClasses("");
                                clearTimeout(timer);
                                setTimer(undefined);
                            }, 3000);
                            setHintColor(StaticColours.forumm_red);
                            setDynamicClasses("animate-shake-input");
                            setTimer(timeout);
                        }
                        value = maxValue.toString();
                        val = maxValue.toString();
                    }
                    onChange && onChange(val, isInvalid);
                },
                type: "number",
                autoComplete: "on",
                placeholder: placeholder,
                className: "w-full transition-all bg-transparent ".concat(border, " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " rounded-2xl pl-8 pr-4 py-4 text-sm outline-none placeholder-gray-500")
            })
        ]
    });
    const bgHint = theme.type === "DARK" ? "bg-midnight-dark" : "bg-white";
    var ref;
    const backgroundColour = (ref = labelBgColour !== null && labelBgColour !== void 0 ? labelBgColour : theme === null || theme === void 0 ? void 0 : theme.backgroundColourSecondary) !== null && ref !== void 0 ? ref : "#0D0E11";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "".concat([
            "flex flex-col my-4",
            className
        ].join(" "), "  ").concat(dynamicClasses),
        style: {
            color: textColour
        },
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm mb-2 ml-2 z-10 ".concat(backgroundColour, " ").concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    background: backgroundColour,
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        backgroundColor: backgroundColour
                    },
                    className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                    children: label
                })
            }),
            input,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                style: {
                    color: hintColor
                },
                children: hint
            })
        ]
    });
};


/***/ }),

/***/ 39618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73912);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);






/**
 * Primary UI component for text input
 */ const TextInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , type ="text" , border ="border" , onKeyDown , onBlur , max , min , textColour , disabled , testid , name , tooltip , show =true , customClassLabel ="" , error =undefined , setError , autoComplete , ignoreDefaultValidations =false , variation ="v1" , forceLabel =false , disableInlineErrors =false  } = param;
    const fieldTypeValidations = ignoreDefaultValidations ? validations : (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(type, validations);
    let errorMessage = error !== null && error !== void 0 ? error : (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, fieldTypeValidations);
    // if (errorMessage)
    // console.log({ errMessage: errorMessage, fieldTypeValidations })
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    const [showPassword, setShowPassword] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    // useEffect(() => {
    //   if (errorMessage) console.log({ errorMessage, fieldTypeValidations })
    // }, [errorMessage])
    if (value === null) value = "";
    const generateStyles = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        let base = "transition-all outline-none rounded bg-white/70 focus:ring-0";
        let errorStyles = errorMessage ? "text-red-500 border-red-500 focus:border-red-500" : "border-gray-300 focus:border-forumm-blue";
        const disabledStyles = disabled ? "!text-gray-500 bg-gray-100 border-gray-300 cursor-not-allowed" : "";
        let textStyles = "text-sm placeholder-gray-500";
        let positionStyles = "h-11 px-3 py-2";
        let sizeStyles = "w-full";
        const passwordStyles = type === "password" ? "pr-11" : "";
        if (variation === "v2") {
            base = "!bg-white rounded-none border-black";
            errorStyles = errorMessage ? "text-red-500 border-red-500" : "";
            textStyles = "text-sm placeholder-black font-semibold";
            positionStyles = "px-4 py-4";
        }
        const payload = "".concat(base, " ").concat(textStyles, " ").concat(positionStyles, " ").concat(border, " ").concat(errorStyles, " ").concat(disabledStyles, " ").concat(passwordStyles, " ").concat(sizeStyles, " ").concat(className);
        return payload;
    }, [
        border,
        className,
        disabled,
        errorMessage,
        type,
        variation
    ]);
    const input = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            "data-testid": testid !== null && testid !== void 0 ? testid : null,
            required: required,
            value: value,
            onKeyDown: onKeyDown,
            onBlur: onBlur,
            onChange: (e)=>{
                const val = e.target.value;
                errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(val, fieldTypeValidations);
                // console.log({ errorMessage, target: val, fieldTypeValidations })
                // setErrorMessage(errorMsg ?? '')
                const isInvalid = errorMessage !== "";
                var ref;
                if (!!setError && typeof errorMessage === "string") setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
                if (!!onChange) onChange(val, isInvalid);
            },
            max: max,
            disabled: disabled,
            min: min,
            type: showPassword ? "text" : type,
            placeholder: placeholder,
            autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : label,
            id: label,
            className: generateStyles,
            style: {
                color: textColour
            }
        }), [
        testid,
        required,
        value,
        onKeyDown,
        onBlur,
        onChange,
        max,
        disabled,
        min,
        type,
        placeholder,
        autoComplete,
        label,
        generateStyles,
        textColour,
        errorMessage,
        fieldTypeValidations,
        setError,
        showPassword
    ]);
    const labelRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const showLabel = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>label && variation === "v1" || forceLabel, [
        label,
        variation,
        forceLabel
    ]);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col my-3",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            showLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                ref: labelRef,
                className: "mb-1.5 text-sm font-medium leading-5 transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    show: showTooltip,
                    tooltip: tooltip,
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "z-10 \n                ".concat(variation === "v2" ? "text-black font-semibold" : "", "\n                ").concat(customClassLabel, " \n                ").concat(required ? "after:content-['*'] after:ml-1 after:text-red-500" : ""),
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "relative",
                children: [
                    input,
                    type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "absolute right-3 top-1/2 flex -translate-y-1/2 cursor-pointer items-center text-lg",
                        onClick: ()=>setShowPassword(!showPassword),
                        children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdVisibility */ .t2l, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdVisibilityOff */ .wqE, {})
                    })
                ]
            }),
            errorMessage && !disableInlineErrors && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                textColour: "foregroundTextColour",
                className: "transition-all text-red-500 text-xs font-bold mt-1",
                children: errorMessage
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                style: {
                    color: textColour
                },
                children: hint
            })
        ]
    });
};


/***/ }),

/***/ 26052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaThumbnail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40654);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63696);
/* harmony import */ var _components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38999);





const MediaThumbnail = (param)=>{
    let { show =true , style ={} , media , key , size ="sm" , className ="" , alt , timeout =3000 , onClick =(e)=>{}  } = param;
    const [thumbnail, setThumbnail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const sizeClasses = {
        any: "",
        xs: "h-6 w-6",
        sm: "h-8 w-8",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (async ()=>{
            if (media) {
                setLoading(true);
                await (0,_libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__/* .getContentThumbnail */ .Lb)(media).then((data)=>{
                    setThumbnail(data);
                    setLoading(false);
                }).catch((err)=>{
                    console.error(err);
                    setLoading(false);
                });
            }
        })();
    }, [
        media
    ]);
    setTimeout(()=>setLoading(false), timeout);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!thumbnail && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    if (!thumbnail) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        style: style,
        onClick: (e)=>onClick(e),
        className: "".concat(sizeClasses[size], " ").concat(className, " object-cover"),
        alt: alt !== null && alt !== void 0 ? alt : "Media thumbnail",
        src: thumbnail,
        draggable: false
    }, key);
};


/***/ }),

/***/ 39615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ DonationPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/images/default-thumbnail.png
var default_thumbnail = __webpack_require__(96963);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 10 modules
var Wrapper = __webpack_require__(41702);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(91291);
// EXTERNAL MODULE: ./graphql/events/GetEventByDonationUrl.ts
var GetEventByDonationUrl = __webpack_require__(95746);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/TextLink.tsx
var TextLink = __webpack_require__(82316);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
;// CONCATENATED MODULE: ./components/base/ProgressWheel.tsx




const ProgressWheel = (param)=>{
    let { fillColor , bgColor , diameter =140 , percentageComplete  } = param;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "rounded-full relative flex justify-center items-center",
        style: {
            width: diameter,
            height: diameter,
            background: fillColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "rounded-full absolute flex justify-center items-center text-5xl",
                style: {
                    width: diameter * 0.9,
                    height: diameter * 0.9,
                    background: theme.foregroundColour,
                    color: bgColor
                },
                children: [
                    Math.round(percentageComplete),
                    "%"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-full h-full absolute top-0 left-0",
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                style: {
                    transform: "rotate(-90deg)",
                    fill: "none",
                    stroke: bgColor,
                    strokeWidth: diameter * 0.05,
                    strokeDasharray: Math.PI * diameter,
                    strokeDashoffset: Math.PI * diameter * (1 - percentageComplete / 100),
                    strokeLinecap: "butt",
                    strokeOpacity: percentageComplete > 0 ? "100" : "0",
                    transition: "all ease-out ".concat(percentageComplete * 10 + 50, "ms")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: diameter / 2,
                    cy: diameter / 2,
                    r: diameter * 0.95 / 2
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
;// CONCATENATED MODULE: ./components/donation/DonationProgressWheel.tsx










const DONATION_WHEEL_CONFIG = {
    disabled: [
        "d9232843-4c2d-4f7f-b2d8-ab89499cd9d1",
        "d9232843-4c2d-4f7f-b2d8-ab89499cd9d2",
        "cd54965b-4538-44bf-b177-1f0837706cee",
        "b9504ce6-f68e-4f31-a6cf-df99d55a113e",
        "196ae88a-ab1f-42d9-a26f-ca9f9122fc87",
        "a4d4f37e-f4fe-41d5-863d-d9d254e404a1"
    ]
};
const DonationProgressWheel = (param)=>{
    let { currentAmount , donationGoal , numberOfDonators , currency , isLoading , donationAction , merchantNotConfigured , loadingMerchantInfo  } = param;
    var ref, ref1;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    const router = (0,next_router.useRouter)();
    const isDarkTheme = theme.type === "DARK";
    const defaultColor = isDarkTheme ? StaticColours.forumm_blue_light : StaticColours.v2.blue;
    const color = currentAmount >= donationGoal ? theme.successColour : defaultColor;
    const buttonTextColorClass = isDarkTheme ? "text-forumm-light-blue-dark" : "text-forumm-selected-menu-blue";
    const iconFillColor = isDarkTheme ? StaticColours.forumm_share_dark : StaticColours.v2.blue_share;
    const [shareButtonText, setShareButtonText] = (0,react.useState)("Share");
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const isAdmin = profile === null || profile === void 0 ? void 0 : (ref = profile.groups) === null || ref === void 0 ? void 0 : ref.includes("forumm-admin");
    const isOrganizer = profile === null || profile === void 0 ? void 0 : (ref1 = profile.groups) === null || ref1 === void 0 ? void 0 : ref1.includes("organizer");
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex items-center justify-center my-auto h-[486px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                size: "medium"
            })
        });
    }
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex items-center justify-center flex-col px-4 space-y-2 mt-11 mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mb-3 hover:animate-jello-horizontal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressWheel, {
                    fillColor: currentAmount >= donationGoal ? theme.successColour : theme.wheelColour,
                    bgColor: currentAmount >= donationGoal ? theme.successColour : theme.type === "DARK" ? StaticColours.forumm_blue_light : StaticColours.v2.blue,
                    diameter: 200,
                    percentageComplete: donationGoal === 0 ? 100 : currentAmount / donationGoal * 100
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "font-medium text-[36px] mb-2",
                style: {
                    color
                },
                children: [
                    (ref2 = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref2 !== void 0 ? ref2 : "$",
                    (0,util/* roundAmount */.Bq)(currentAmount)
                ]
            }),
            (isOrganizer || isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "text-md",
                children: [
                    "Raised of",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            color
                        },
                        className: "font-medium",
                        children: [
                            (ref3 = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref3 !== void 0 ? ref3 : "$",
                            (0,util/* roundAmount */.Bq)(donationGoal)
                        ]
                    }),
                    " ",
                    "target by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color
                        },
                        className: "font-medium",
                        children: numberOfDonators
                    }),
                    " ",
                    "donations."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: "40px"
                },
                children: [
                    !loadingMerchantInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: ()=>{
                            donationAction();
                        },
                        type: "primary",
                        title: "Donate",
                        className: "",
                        size: "full",
                        disabled: merchantNotConfigured
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "w-[180px] mt-2 border-none ".concat(buttonTextColorClass, " text-xs flex items-center justify-center"),
                        title: shareButtonText,
                        textColor: theme.tealColour,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "13",
                            height: "16",
                            viewBox: "1 -1 12 15",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mr-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M11.375 0.601562H4.625C3.8 0.601562 3.125 1.27656 3.125 2.10156V11.1016C3.125 11.9266 3.8 12.6016 4.625 12.6016H11.375C12.2 12.6016 12.875 11.9266 12.875 11.1016V2.10156C12.875 1.27656 12.2 0.601562 11.375 0.601562ZM11.375 11.1016H4.625V2.10156H11.375V11.1016ZM0.125 10.3516V8.85156H1.625V10.3516H0.125ZM0.125 6.22656H1.625V7.72656H0.125V6.22656ZM5.375 14.1016H6.875V15.6016H5.375V14.1016ZM0.125 12.9766V11.4766H1.625V12.9766H0.125ZM1.625 15.6016C0.8 15.6016 0.125 14.9266 0.125 14.1016H1.625V15.6016ZM4.25 15.6016H2.75V14.1016H4.25V15.6016ZM8 15.6016V14.1016H9.5C9.5 14.9266 8.825 15.6016 8 15.6016ZM1.625 3.60156V5.10156H0.125C0.125 4.27656 0.8 3.60156 1.625 3.60156Z"
                            })
                        }),
                        type: "tertiary",
                        size: "small",
                        onClick: (e)=>{
                            navigator.clipboard.writeText("https://".concat(window.location.hostname).concat(router.asPath));
                            setShareButtonText("Copied!");
                            setTimeout(()=>{
                                setShareButtonText("Share");
                            }, 3000);
                            e.preventDefault();
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var index_esm = __webpack_require__(66653);
;// CONCATENATED MODULE: ./components/donation/DonationWall.tsx









const visibilityChoices = {
    NAME_AMOUNT: "Name & amount",
    NAME: "Name only",
    ANON: "Anonymous"
};
const getTimeSinceDonation = (time)=>{
    if (!time) return "";
    try {
        const timestamp = typeof time === "string" ? parseInt(time, 10) : time;
        const momentTime = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
        return moment_default()(momentTime).fromNow();
    } catch (e) {
        console.warn({
            e
        });
        return "";
    }
};
const noDonationsPage = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
    className: "text-xl pt-4",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex flex-row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-row space-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-xs md:text-sm",
                    children: "There are no donations yet, be the first!"
                })
            })
        })
    })
});
const DonationWall = (param)=>{
    let { donations , donationAction , customClassName  } = param;
    const [donationIndex, setDonationsIndex] = (0,react.useState)(1);
    const amountToShow = 5;
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    const color = theme.type === "DARK" ? StaticColours.forumm_blue_light : StaticColours.v2.blue;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-col w-full p-2 overflow-y-auto max-h-[calc(90vh-17px)] ".concat(customClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-row items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-normal text-3xl",
                        children: "Donation Wall"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "font-medium mr-6 md:mr-0",
                        children: [
                            (ref = donations === null || donations === void 0 ? void 0 : donations.length) !== null && ref !== void 0 ? ref : 0,
                            " donations"
                        ]
                    })
                ]
            }),
            donations.length < 1 ? noDonationsPage : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-col flex-grow h-full overflow-y-auto scrollbar-custom",
                children: donations.sort((a, b)=>a.created && b.created ? a.created < b.created ? 1 : -1 : 0).map((dono, i)=>{
                    const { firstName , lastName , message , amount , created , currency , avatarUrl , coverFee , selectedProgram: programme , donation , visibility , fee  } = dono;
                    const donationAmount = (()=>{
                        try {
                            const donationval = parseFloat(donation);
                            const feeVal = parseFloat(fee);
                            if (!!donation && donationval > 0) {
                                if (coverFee === "no" || coverFee === "false") return donationval + feeVal;
                                return donationval;
                            }
                        } catch (err) {
                            console.log(err);
                            return amount;
                        }
                        return amount;
                    })();
                    const isAnon = (visibility === null || visibility === void 0 ? void 0 : visibility.toLowerCase()) === visibilityChoices.ANON.toLowerCase();
                    const showAmount = (visibility === null || visibility === void 0 ? void 0 : visibility.toLowerCase()) === visibilityChoices.NAME_AMOUNT.toLowerCase();
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "font-medium text-xl py-4 -mt-3 mr-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "flex flex-row w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            style: {
                                                width: "80px"
                                            },
                                            className: "flex flex-col mt-3 ml-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png",
                                                alt: "Logo",
                                                width: 40,
                                                height: 40,
                                                className: "rounded-full object-cover h-[40px] border border-1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex flex-col w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-row justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-sm text-sm font-medium mt-2 mb-4",
                                                            children: !isAnon ? firstName + " " + lastName : "Anonymous"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-xs font-light -mt-2 mr-6 xl:mr-2",
                                                            children: created ? getTimeSinceDonation("".concat(created)) : ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex flex-col justify-between -mt-2 mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        show: !!message,
                                                        className: "text-xs text-left font-light text-sm",
                                                        children: message
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "text-sm font-medium flex flex-row items-center",
                                                    style: {
                                                        color
                                                    },
                                                    children: [
                                                        !showAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "donated to"
                                                        }),
                                                        showAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                currency ? currencies/* default */.Z === null || currencies/* default */.Z === void 0 ? void 0 : currencies/* default */.Z[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()].symbol : "\xa3",
                                                                (donationAmount / 100).toFixed(2)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            show: !!programme,
                                                            className: "text-xs flex items-center gap-1 pl-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GoArrowRight */.e$1, {}),
                                                                programme
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "h-[2px] bg-gray-200 w-3/4 sm:w-full mx-auto"
                            })
                        ]
                    }, "".concat(i));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-row space-x-2 pt-4 items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    show: donations.length > 5 && donationIndex * amountToShow >= donations.length,
                    className: "w-[180px]",
                    title: "Go Back",
                    type: "secondary",
                    size: "auto",
                    onClick: ()=>{
                        if (donationIndex * amountToShow >= donations.length) setDonationsIndex(1);
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./components/donation/DonationForm.tsx + 4 modules
var DonationForm = __webpack_require__(61344);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/eventDonationListTransactions.ts

const EVENT_DONATON_LIST_TRANSACTIONS = (0,_generated/* graphql */.B)("\n  query eventDonationListTransactions(\n    $eventId: String\n    $donationUrl: String\n    $eventName: String\n  ) {\n    eventDonationListTransactions(\n      eventId: $eventId\n      donationUrl: $donationUrl\n      eventName: $eventName\n    ) {\n      transactions {\n        firstName\n        lastName\n        amount\n        currency\n        eventId\n        eventName\n        message\n        coverFee\n        fee\n        donation\n        total\n        created\n        address\n        giftAid\n        selectedProgram\n        email\n        visibility\n        donorDob\n        paymentType\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(29039);
;// CONCATENATED MODULE: ./components/carousel/prepareCarouselItems.ts
const defaultOptions = {
    coverImage: "https://assets.tumblr.com/images/default_header/optica_pattern_11.png",
    title: "Foundraising Title",
    description: "The program of inspirational talks stands out at our event. Experts share innovative visions about the future. In addition, interactive workshops offer practical skills to apply in real life."
};
const prepareCarouselItems = (param)=>{
    let { media , options  } = param;
    if (!options) options = defaultOptions;
    if (!options.coverImage) options.coverImage = defaultOptions.coverImage;
    if (!options.title) options.title = defaultOptions.title;
    if (!options.description) options.description = defaultOptions.description;
    const { coverImage , title , description  } = options;
    if (media.length === 0) return [];
    return media.map((item)=>{
        var _title, _description;
        return {
            url: item.url,
            title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
            description: (_description = item.description) !== null && _description !== void 0 ? _description : ""
        };
    });
};

// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/event/Card.tsx
var Card = __webpack_require__(21867);
;// CONCATENATED MODULE: ./graphql/events/getFundrasingCSV.ts

const GET_FUNDRAISING_CSV = (0,_generated/* graphql */.B)("\n  query GetFundraisingCSV($eventId: String) {\n    getFundraisingCSV(eventId: $eventId)\n  }\n");

// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
;// CONCATENATED MODULE: ./components/donation/DonationGrid.tsx









const DonationGrid = (param)=>{
    let { donations , eventId  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const classHead = "p-2 md:p-3 border border-forumm-menu-border text-center font-bold";
    const classRow = "p-2 md:p-3 mt-2 text-center break-words";
    const getSymbol = (cr)=>{
        return cr ? currencies/* default */.Z === null || currencies/* default */.Z === void 0 ? void 0 : currencies/* default */.Z[cr === null || cr === void 0 ? void 0 : cr.toUpperCase()].symbol : "\xa3";
    };
    const getAmount = (amount, cr)=>{
        if (!amount) return "N/A";
        const value = typeof amount === "string" ? parseInt(amount, 10) : amount;
        return "".concat(getSymbol(cr !== null && cr !== void 0 ? cr : "")).concat((value / 100).toFixed(2));
    };
    const getFee = (tx)=>{
        if (!tx) return "";
        if (tx.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit) return 0;
        if (!!tx.fee) return parseInt(tx.fee);
        return 0;
    };
    const [getFundraisingCSVData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(GET_FUNDRAISING_CSV);
    const downloadCSV = async ()=>{
        const csv = await getFundraisingCSVData({
            variables: {
                eventId
            }
        }).then((d)=>{
            var ref;
            return (ref = d.data) === null || ref === void 0 ? void 0 : ref.getFundraisingCSV;
        });
        const blob = new Blob([
            "\uFEFF" + csv
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "donations.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-col h-full w-full p-2 ml-6 md:ml-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-row items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-medium text-3xl",
                        children: "Organiser Overview"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "font-medium mr-6 md:mr-0",
                        children: [
                            (ref = donations === null || donations === void 0 ? void 0 : donations.length) !== null && ref !== void 0 ? ref : 0,
                            " donations"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "block sm:hidden text-center p-4",
                children: "To view this content, please use a larger device."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                color: "backgroundColourSecondary",
                className: "hidden sm:grid col-span-5 grid-cols-5 border-collapse text-xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Date"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Donor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "Gift Aid"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: classHead,
                        children: "PaymentType"
                    }),
                    donations.sort((a, b)=>a.created && b.created ? a.created < b.created ? 1 : -1 : 0).map((tx)=>{
                        const totalAmount = tx.donation && parseInt(tx.donation) > 0 ? parseInt(tx.donation) + parseInt(tx.fee) : tx.amount;
                        const fee = getAmount(getFee(tx));
                        const isDD = tx.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid col-span-5 grid-cols-5 border-forumm-menu-border border-2 -mt-1",
                            style: {
                                background: theme.backgroundColourSecondary
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "".concat(classRow),
                                    children: tx.datetime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "".concat(classRow),
                                    children: "".concat(tx.firstName, " ").concat(tx.lastName, " (").concat(tx.email, ")")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: getAmount(totalAmount, tx.currency)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: (tx === null || tx === void 0 ? void 0 : tx.giftAid) ? tx.giftAid.toUpperCase() : ""
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: classRow,
                                    children: (tx === null || tx === void 0 ? void 0 : tx.paymentType) ? tx.paymentType.toUpperCase() : "N/A"
                                }),
                                " "
                            ]
                        }, tx.created);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex items-center justify-between pt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "text-center pl-3 md:pl-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Export CSV",
                        onClick: downloadCSV,
                        className: "ml-2 text-white whitespace-nowrap",
                        loading: loading
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var donation_DonationGrid = (DonationGrid);

// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/donation/[donationUrl]/index.tsx

































const stripePublicKey = "pk_live_jP3Sfq8LMnLnup6TR2O9tA6u";
const addManualDonations = (eventId, payload)=>{
    var ref;
    // NOTE: Launch Foods Fundraiser
    if (eventId === "7f31134c-bc71-490a-9705-7e0dfa085f8e" && payload && ((ref = payload[0]) === null || ref === void 0 ? void 0 : ref.fee) !== "0") {
        payload.unshift({
            amount: 600000,
            firstName: "GREN",
            lastName: "UK",
            currency: "gbp",
            message: "We are delighted to support such a wonderful cause.",
            created: 1736244994,
            datetime: "07/01/2025 10:16:34",
            coverFee: "no",
            donation: "600000",
            fee: "0",
            giftAid: "no",
            selectedProgram: "Launch Foods Foundation",
            visibility: "Name & amount",
            avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
        });
        payload.unshift({
            amount: 250000,
            firstName: "Cruin",
            lastName: "Consulting",
            currency: "gbp",
            message: "Proud to support Launch foods as always.",
            created: 1736244994,
            datetime: "07/01/2025 10:16:34",
            coverFee: "no",
            donation: "250000",
            fee: "0",
            giftAid: "no",
            selectedProgram: "Launch Foods Foundation",
            visibility: "Name & amount",
            avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
        });
    }
};
var __N_SSP = true;
function DonationPage(param) {
    let { metadata , eventDonationUrl  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    console.log({
        inPage: metadata
    });
    const router = (0,next_router.useRouter)();
    const { theme , setTheme  } = (0,useTheme/* useTheme */.Fg)();
    const donationUrl = eventDonationUrl || router.query.donationUrl;
    const { profile , isAdmin , isOrganizer , isLogged , canEditEvent  } = (0,useAuth/* useAuth */.aC)();
    const [isMounted, setIsMounted] = (0,react.useState)(false);
    const forceUSD = [
        "sussex-hardship-appeal-us"
    ].includes(donationUrl);
    const { data , loading: eventLoading , error: eventError  } = (0,useQuery/* useQuery */.a)(GetEventByDonationUrl/* GET_EVENT_BY_DONATION_URL */.I, {
        variables: {
            input: {
                donationUrl: donationUrl
            }
        },
        skip: !donationUrl
    });
    const [stripePromise, setStripePromise] = (0,react.useState)(null);
    const [merchantNotConfigured, setMerchantNotConfigured] = (0,react.useState)(false);
    const [loadingMerchantInfo, setLoadingMerchantInfo] = (0,react.useState)(true);
    const organizer = (ref = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl.event) === null || ref === void 0 ? void 0 : ref.organizationName;
    const { profile: organisationProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(organizer !== null && organizer !== void 0 ? organizer : "");
    (0,react.useEffect)(()=>{
        if (!!theme && theme.organisationName !== organizer) {
            setTheme({
                ...theme,
                organisationName: organizer
            });
        }
    }, [
        theme.organisationName,
        organizer
    ]);
    (0,react.useEffect)(()=>{
        if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.name) {
            setLoadingMerchantInfo(false);
            if (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.merchant) {
                const stripeAccount = organisationProfile.merchant;
                setStripePromise((0,stripe_esm/* loadStripe */.J)(stripePublicKey, {
                    stripeAccount
                }));
            } else {
                setMerchantNotConfigured(true);
            }
        }
    }, [
        organisationProfile
    ]);
    const selectedCurrency = forceUSD ? "USD" : organisationProfile.currency;
    const currencyInfo = currencies/* default */.Z[selectedCurrency.toUpperCase()];
    const platformFee = (organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.percentage) !== undefined ? organisationProfile.percentage : 10;
    var ref15;
    const feeAbsorption = (ref15 = data === null || data === void 0 ? void 0 : (ref1 = data.getEventByDonationUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fundraising) === null || ref2 === void 0 ? void 0 : ref2.feeAbsorption) !== null && ref15 !== void 0 ? ref15 : false;
    const dynamicStyle = (0,util/* getDynamicStyle */.nT)(theme.highlightColour);
    const [isDonationModalOpen, setDonationModalOpen] = (0,react.useState)(false);
    const [generalLoading, setGeneralLoading] = (0,react.useState)(false);
    const [hideDonationWheel, setHideDonationWheel] = (0,react.useState)(true);
    const [canGoBack, setCanGoBack] = (0,react.useState)(false);
    const [fetchDonations, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(EVENT_DONATON_LIST_TRANSACTIONS, {
        fetchPolicy: "network-only"
    });
    const [donationFormInitialValue, setDonationFormInitialValue] = (0,react.useState)({});
    const [donationData, setDonationData] = (0,react.useState)();
    const [programmeData, setProgrammeData] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (window && window.history && window.history.length > 2) {
            setCanGoBack(true);
        }
    }, []);
    const eventId = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl.eventId;
    const fundraisingData = data === null || data === void 0 ? void 0 : (ref3 = data.getEventByDonationUrl) === null || ref3 === void 0 ? void 0 : ref3.fundraising;
    const eventDetails = data === null || data === void 0 ? void 0 : (ref4 = data.getEventByDonationUrl) === null || ref4 === void 0 ? void 0 : ref4.event;
    const getDonations = (0,react.useCallback)(()=>{
        if (eventId && !DONATION_WHEEL_CONFIG.disabled.includes(eventId)) {
            setHideDonationWheel(false);
        }
        fetchDonations({
            variables: {
                eventId: eventId,
                donationUrl: donationUrl
            }
        }).then((d)=>{
            var ref;
            var ref1;
            const payload = (ref1 = d === null || d === void 0 ? void 0 : (ref = d.data) === null || ref === void 0 ? void 0 : ref.eventDonationListTransactions.transactions.map((tx)=>{
                var ref, ref1;
                var _firstName, _lastName, _currency, _message, ref2, ref3, ref4, ref5, ref6, ref7;
                return {
                    amount: typeof (tx === null || tx === void 0 ? void 0 : tx.amount) === "number" ? tx === null || tx === void 0 ? void 0 : tx.amount : parseInt(tx.amount),
                    firstName: (_firstName = tx.firstName) !== null && _firstName !== void 0 ? _firstName : "Anonymous",
                    lastName: (_lastName = tx.lastName) !== null && _lastName !== void 0 ? _lastName : "",
                    currency: (_currency = tx.currency) !== null && _currency !== void 0 ? _currency : selectedCurrency,
                    message: (_message = tx.message) !== null && _message !== void 0 ? _message : undefined,
                    created: tx === null || tx === void 0 ? void 0 : tx.created,
                    datetime: (tx === null || tx === void 0 ? void 0 : tx.created) ? moment_default()(tx.created * 1000).format("DD/MM/YYYY HH:mm:ss") : "",
                    address: (ref2 = tx === null || tx === void 0 ? void 0 : tx.address) !== null && ref2 !== void 0 ? ref2 : undefined,
                    coverFee: (ref3 = tx === null || tx === void 0 ? void 0 : tx.coverFee) !== null && ref3 !== void 0 ? ref3 : undefined,
                    donation: typeof (tx === null || tx === void 0 ? void 0 : tx.donation) === "string" ? tx === null || tx === void 0 ? void 0 : tx.donation : tx === null || tx === void 0 ? void 0 : (ref = tx.donation) === null || ref === void 0 ? void 0 : ref.toString(),
                    fee: typeof (tx === null || tx === void 0 ? void 0 : tx.fee) === "string" ? tx === null || tx === void 0 ? void 0 : tx.fee : tx === null || tx === void 0 ? void 0 : (ref1 = tx.fee) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                    giftAid: (ref4 = tx === null || tx === void 0 ? void 0 : tx.giftAid) !== null && ref4 !== void 0 ? ref4 : undefined,
                    selectedProgram: (ref5 = tx === null || tx === void 0 ? void 0 : tx.selectedProgram) !== null && ref5 !== void 0 ? ref5 : undefined,
                    email: (ref6 = tx === null || tx === void 0 ? void 0 : tx.email) !== null && ref6 !== void 0 ? ref6 : undefined,
                    visibility: (ref7 = tx === null || tx === void 0 ? void 0 : tx.visibility) !== null && ref7 !== void 0 ? ref7 : "Name & amount",
                    donorDob: tx === null || tx === void 0 ? void 0 : tx.donorDob,
                    paymentType: tx === null || tx === void 0 ? void 0 : tx.paymentType,
                    avatarUrl: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/heart-and-hand-donation-icon.png"
                };
            })) !== null && ref1 !== void 0 ? ref1 : [];
            if (eventId) addManualDonations(eventId, payload);
            setDonationData(payload);
            setGeneralLoading(false);
            const programmePayload = payload.filter((p)=>!!p.selectedProgram).map((tx)=>({
                    programme: tx.selectedProgram,
                    amount: tx.amount
                })).reduce((acc, tx)=>{
                if (tx.programme && tx.amount) {
                    const key = tx.programme.toUpperCase().trim().replaceAll(" ", "_");
                    var // @ts-ignore
                    _key;
                    const prevVal = (_key = acc[key]) !== null && _key !== void 0 ? _key : 0;
                    // @ts-ignore
                    acc[key] = prevVal + tx.amount / 100;
                    // NOTE: Temporary Hardcoded programme overwrite for Launch Foods
                    if (key === "LAUNCH_FOODS_CHRISTMAS_TOY_APPEAL_2024") // @ts-ignore
                    acc["LAUNCH_FOODS_CHRISTMAS_TOY_APPEAL"] = prevVal + tx.amount / 100;
                }
                return acc;
            }, {});
            setProgrammeData(programmePayload);
        });
    }, [
        donationUrl,
        eventId
    ]);
    (0,react.useEffect)(()=>{
        if (eventId) {
            setDonationData(undefined);
            setProgrammeData(undefined);
            getDonations();
        }
    }, [
        getDonations,
        eventId
    ]);
    const isDarkTheme = theme.type === "DARK";
    var ref16;
    const eventImage = (ref16 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.bannerImage) !== null && ref16 !== void 0 ? ref16 : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png";
    const eventData = data === null || data === void 0 ? void 0 : data.getEventByDonationUrl;
    const carouselItemsPrepare = prepareCarouselItems({
        media: (data === null || data === void 0 ? void 0 : (ref5 = data.getEventByDonationUrl) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fundraising) === null || ref6 === void 0 ? void 0 : ref6.media) || [],
        options: {
            coverImage: eventImage,
            title: data === null || data === void 0 ? void 0 : (ref7 = data.getEventByDonationUrl) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fundraising) === null || ref8 === void 0 ? void 0 : ref8.title,
            description: data === null || data === void 0 ? void 0 : (ref9 = data.getEventByDonationUrl) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fundraising) === null || ref10 === void 0 ? void 0 : ref10.description
        }
    });
    const checkAuth = (isPublished)=>{
        var ref, ref1, ref2, ref3;
        if (!isLogged) router.push("/");
        if (!isOrganizer && !isAdmin && !isPublished) router.push("/");
        if (!isAdmin && isOrganizer && (eventData === null || eventData === void 0 ? void 0 : (ref = eventData.event) === null || ref === void 0 ? void 0 : ref.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.university) && (eventData === null || eventData === void 0 ? void 0 : (ref1 = eventData.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.company)) router.push("/");
        if (!isAdmin && !isOrganizer && (eventData === null || eventData === void 0 ? void 0 : (ref2 = eventData.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.university) && (eventData === null || eventData === void 0 ? void 0 : (ref3 = eventData.event) === null || ref3 === void 0 ? void 0 : ref3.organizationName) !== (profile === null || profile === void 0 ? void 0 : profile.company)) router.push("/");
    };
    (0,react.useEffect)(()=>{
        if (isLogged && (eventData || eventError) && profile) setIsMounted(true);
        if (!isLogged && (eventData || eventError)) setIsMounted(true);
    }, [
        profile,
        eventData,
        isLogged,
        eventError
    ]);
    (0,react.useEffect)(()=>{
        if (eventError && !eventData && isMounted) {
            router.push("/");
        }
    }, [
        eventError,
        router,
        eventData,
        isMounted
    ]);
    (0,react.useEffect)(()=>{
        if (!!eventData && !eventLoading) {
            var ref;
            if (eventData.isPublished !== true) checkAuth(false);
            if (((ref = eventData.event) === null || ref === void 0 ? void 0 : ref.publiclyListed) !== true) checkAuth(eventData.isPublished === true);
        }
    }, [
        isMounted
    ]);
    if (!(eventData === null || eventData === void 0 ? void 0 : eventData.eventId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {});
    }
    var _title, ref17;
    // Added auto-generated default fundrasing programme.
    const programmes = [
        {
            description: eventDetails.description,
            goal: fundraisingData.goal,
            media: eventDetails.bannerImage,
            title: (_title = fundraisingData.title) !== null && _title !== void 0 ? _title : "Main Fund",
            active: true,
            enabled: true
        },
        ...(ref17 = fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.programs) !== null && ref17 !== void 0 ? ref17 : []
    ];
    const pageUrl = "https://app.".concat("forumm.to").concat(router.asPath);
    const ogData = (()=>{
        var ref, ref1;
        const payload = {
            url: "https://images-prod.forumm.to/user-content/f23a4ed7-44e0-4176-a7d0-93f4efae2caa/jpa.png",
            alt: "Forumm",
            desc: "Event management and fundraising made simple."
        };
        if (!eventData || !eventData.event) return payload;
        if (!!eventData.event.bannerImage) {
            payload.url = eventData.event.bannerImage;
            var _shortDescription;
            payload.alt = (_shortDescription = eventData.event.shortDescription) !== null && _shortDescription !== void 0 ? _shortDescription : eventData.event.title;
        } else if (!!((ref = eventData.fundraising) === null || ref === void 0 ? void 0 : (ref1 = ref.media) === null || ref1 === void 0 ? void 0 : ref1[0])) {
            payload.url = eventData.fundraising.media[0].url;
            payload.alt = eventData.fundraising.media[0].title;
        }
        var _shortDescription1;
        payload.desc = (_shortDescription1 = eventData.event.shortDescription) !== null && _shortDescription1 !== void 0 ? _shortDescription1 : eventData.event.title;
        return payload;
    })();
    let mediaType = "VIDEO";
    let videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background.mp4";
    if (donationUrl === "sussexfund") {
        mediaType = "IMG";
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Sussex+Area+of+Greatest+Need.jpg";
    }
    if (donationUrl === "university-of-sussex-585354") {
        mediaType = "IMG";
        videoUrl = "https://s3.amazonaws.com/i.snag.gy/4y39rX.jpg";
    }
    if (eventData.eventId === "cd54965b-4538-44bf-b177-1f0837706cee") {
        mediaType = "IMG";
        videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Sussex+Banner+Option.png";
    }
    if ((eventData === null || eventData === void 0 ? void 0 : eventData.eventId) === "c2cba07a-a403-440c-8f0e-6f0788ad907b") videoUrl = "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Infinite+Intentions+Video+(1).mp4";
    var ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (ref18 = (ref11 = eventData.event) === null || ref11 === void 0 ? void 0 : ref11.title) !== null && ref18 !== void 0 ? ref18 : "Forumm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ogData.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogData.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: ogData.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: "image/jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "overflow-y-scroll overflow-x-hidden h-[calc(100vh)] -mt-[80px] pt-[80px] relative",
                children: [
                    stripePromise ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
                        stripe: stripePromise,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationForm/* default */.Z, {
                            eventDetails: eventDetails,
                            programs: programmes,
                            eventId: eventId,
                            isOpen: isDonationModalOpen,
                            setIsOpen: setDonationModalOpen,
                            organisationCurrency: selectedCurrency,
                            platformFee: platformFee,
                            feeAbsorption: feeAbsorption,
                            refetchDonations: ()=>{
                                setGeneralLoading(true);
                                setTimeout(()=>{
                                    getDonations();
                                }, 8000);
                            },
                            initialValue: donationFormInitialValue
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        color: "foregroundColour",
                        style: dynamicStyle,
                        className: "relative px-2 pt-9 pb-9 border-b border-forumm-menu-border",
                        children: [
                            mediaType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                autoPlay: true,
                                loop: true,
                                muted: true,
                                playsInline: true,
                                className: "absolute inset-0 w-full h-full object-cover select-none no-controls",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: videoUrl,
                                    type: "video/mp4"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: videoUrl,
                                alt: "Background Image",
                                className: "absolute inset-0 w-full h-full object-cover select-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                                    color: "backgroundColorBanner",
                                    style: {
                                        background: isDarkTheme ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)",
                                        backdropFilter: "blur(5px)",
                                        WebkitBackdropFilter: "blur(5px)"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "hidden md:flex ml-2 items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "h-full w-full bg-cover bg-center",
                                                    style: {
                                                        backgroundImage: "url('".concat(eventImage, "')")
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "flex flex-row items-center mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                alt: "Thumbnail Image",
                                                                className: "h-10 w-10 rounded-full mr-4 object-cover",
                                                                width: 30,
                                                                height: 30,
                                                                src: (ref19 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.thumbnailImage) !== null && ref19 !== void 0 ? ref19 : default_thumbnail/* default */.Z
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "flex items-center text-[14px]",
                                                                children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-[36px] w-full",
                                                        children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mb-6",
                                                        style: {
                                                            whiteSpace: "pre-wrap"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                                            className: "text-[16px] md:text-[16px] mt-4 mb-4",
                                                            children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.shortDescription
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "mt-10 flex items-center space-x-4",
                                                        children: [
                                                            !loadingMerchantInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                title: "Donate",
                                                                onClick: ()=>{
                                                                    setDonationModalOpen(true);
                                                                },
                                                                type: "primary",
                                                                className: "rounded-full text-[14px] h-[40px] flex items-center justify-center self-end sm:self-center mr-8",
                                                                disabled: merchantNotConfigured
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                show: canGoBack,
                                                                className: "cursor-pointer hover:underline ${isDarkTheme ? '!text-forumm-active-blue' : '!text-forumm-white'} text-center text-sm flex justify-center items-center hover:animate-heartbeat",
                                                                onClick: ()=>router.back(),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineArrowBackIos */.oTp, {}),
                                                                    " Go Back"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                show: isOrganizer && canEditEvent(eventData),
                                                                className: "border-none text-xs flex items-center justify-center hover:underline hover:animate-heartbeat !ml-4",
                                                                title: "Edit",
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdEdit */.zmo, {
                                                                    fontSize: "1.5em"
                                                                }),
                                                                type: "tertiary",
                                                                size: "small",
                                                                onClick: ()=>{
                                                                    router.push("/create-event?id=".concat(eventId));
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "px-2 mt-[70px] mx-auto w-full md:w-[85%] max-w-[1500px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        color: "foregroundColour",
                                        className: "rounded-2xl flex flex-col sm:flex-row border border-forumm-menu-border flex-2 w-full sm:w-auto lg:w-[90%] xl:w-[85%] max-h-[90vh] overflow-y-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "sm:w-2/5 flex flex-col flex-1 justify-start relative p-6 sm:p-10 md:p-12 lg:p-10 ml-6 md:ml-0 min-h-[64px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-row items-center w-full mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            alt: "Thumbnail Image",
                                                            className: "h-16 w-16 rounded-full mr-4 block object-cover hover:animate-heartbeat",
                                                            width: 96,
                                                            height: 96,
                                                            src: (ref20 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.thumbnailImage) !== null && ref20 !== void 0 ? ref20 : default_thumbnail/* default */.Z
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "text-[22px] w-full",
                                                            children: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "text-[36px] w-full mt-4",
                                                    children: fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "my-6",
                                                    style: {
                                                        whiteSpace: "pre-wrap"
                                                    },
                                                    children: (fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                                                        descriptionJson: fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.description
                                                    }) : "No description provided."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex flex-col flex-1 w-full sm:w-auto",
                                        children: [
                                            !hideDonationWheel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                color: "foregroundColour",
                                                className: "rounded-2xl flex flex-col p-2 border border-forumm-menu-border w-full mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationProgressWheel, {
                                                    currentAmount: (ref21 = donationData === null || donationData === void 0 ? void 0 : donationData.reduce((acc, val)=>{
                                                        const amount = (val === null || val === void 0 ? void 0 : val.coverFee) === "no" || !(val === null || val === void 0 ? void 0 : val.coverFee) ? val === null || val === void 0 ? void 0 : val.amount : parseInt(val === null || val === void 0 ? void 0 : val.donation);
                                                        return amount / 100 + acc;
                                                    }, 0)) !== null && ref21 !== void 0 ? ref21 : 0,
                                                    donationGoal: (ref22 = data === null || data === void 0 ? void 0 : (ref12 = data.getEventByDonationUrl) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fundraising) === null || ref13 === void 0 ? void 0 : ref13.goal) !== null && ref22 !== void 0 ? ref22 : 0,
                                                    numberOfDonators: (ref23 = donationData === null || donationData === void 0 ? void 0 : donationData.length) !== null && ref23 !== void 0 ? ref23 : 0,
                                                    currency: currencyInfo,
                                                    isLoading: loading || !data || generalLoading,
                                                    donationAction: ()=>setDonationModalOpen(true),
                                                    merchantNotConfigured: merchantNotConfigured,
                                                    loadingMerchantInfo: loadingMerchantInfo
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                color: "foregroundColour",
                                                className: "rounded-2xl flex flex-col flex-grow p-2 border border-forumm-menu-border w-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationWall, {
                                                    donations: donationData !== null && donationData !== void 0 ? donationData : [],
                                                    customClassName: hideDonationWheel ? "" : "max-h-[300px]",
                                                    donationAction: ()=>setDonationModalOpen(true)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 mt-6 mb-8 h-full",
                                children: carouselItemsPrepare.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    color: "foregroundColour",
                                    className: "flex flex-2 flex-col size-full lg:w-[90%] xl:w-[85%] relative rounded-2xl overflow-hidden border border-forumm-menu-border py-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                                        show: carouselItemsPrepare.length > 0,
                                        items: carouselItemsPrepare
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                show: ((ref24 = fundraisingData === null || fundraisingData === void 0 ? void 0 : fundraisingData.programs) !== null && ref24 !== void 0 ? ref24 : []).length > 0,
                                className: "flex items-stretch justify-between flex-wrap gap-4",
                                children: fundraisingData === null || fundraisingData === void 0 ? void 0 : (ref14 = fundraisingData.programs) === null || ref14 === void 0 ? void 0 : ref14.map((program)=>{
                                    var ref, ref1;
                                    var ref2;
                                    const raised = (0,util/* roundAmount */.Bq)((ref2 = programmeData === null || programmeData === void 0 ? void 0 : programmeData[program.title.toUpperCase().trim().replaceAll(" ", "_")]) !== null && ref2 !== void 0 ? ref2 : 0);
                                    var ref3;
                                    const currencySymbol = forceUSD ? "USD" : currencies/* default */.Z[(ref3 = (ref = eventData.event) === null || ref === void 0 ? void 0 : ref.currency) !== null && ref3 !== void 0 ? ref3 : "GBP"].symbol;
                                    const percentage = Number(raised) / Number(program.goal) * 100;
                                    var ref4, ref5;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                        className: "!rounded-2xl mb-4 max-w-[100%] sm:max-w-[30%] w-full overflow-hidden border border-forumm-menu-border min-h-[300px]",
                                        imgSrc: (ref4 = (ref1 = program.media) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref4 !== void 0 ? ref4 : default_thumbnail/* default.src */.Z.src,
                                        fixedWidth: false,
                                        ratio: "aspect-auto",
                                        onClick: ()=>{
                                            if (program.active) {
                                                setDonationFormInitialValue({
                                                    ...donationFormInitialValue,
                                                    selectedProgram: program.title.toUpperCase()
                                                });
                                                setDonationModalOpen(true);
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex size-full flex-col justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex justify-center flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-2xl",
                                                            children: program.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm text-left mt-1",
                                                            children: (0,util/* truncateString */.aS)((ref5 = program === null || program === void 0 ? void 0 : program.description) !== null && ref5 !== void 0 ? ref5 : "", 150)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            className: "my-2",
                                                            style: {
                                                                opacity: program.goal || raised ? 1 : 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                    className: "flex justify-between text-sm",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                    children: "".concat(currencySymbol).concat(raised)
                                                                                }),
                                                                                " Raised"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                children: "".concat(currencySymbol).concat(program.goal)
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "mt-1 bg-forumm-white ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " rounded-xl"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "h-2 rounded-xl bg-forumm-blue-light",
                                                                        style: {
                                                                            width: "".concat(Math.min(percentage, 100), "%")
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "flex justify-end gap-2 cursor-pointer w-full mt-2 hover:underline text-xs",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                disabled: !program.active,
                                                                title: !!program.active ? "Donate" : "Closed",
                                                                size: "full",
                                                                onClick: ()=>{
                                                                    setDonationFormInitialValue({
                                                                        ...donationFormInitialValue,
                                                                        selectedProgram: program.title.toUpperCase()
                                                                    });
                                                                    setDonationModalOpen(true);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, "".concat(program.title.trim().replaceAll(" ", "_")));
                                })
                            }),
                            eventData && canEditEvent(eventData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                color: "foregroundColour",
                                className: "rounded-2xl flex flex-col sm:flex-row p-2 border border-forumm-menu-border w-full flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(donation_DonationGrid, {
                                    donations: (ref25 = donationData === null || donationData === void 0 ? void 0 : donationData.filter((tx)=>{
                                        return tx === null || tx === void 0 ? void 0 : tx.created;
                                    })) !== null && ref25 !== void 0 ? ref25 : [],
                                    eventId: eventId !== null && eventId !== void 0 ? eventId : eventData.eventId
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "text-center mb-10 mt-10 cursor-pointer ".concat(isDarkTheme ? "!text-forumm-active-blue" : "!text-forumm-white", " hover:underline flex justify-center items-center hover:animate-heartbeat ").concat(window.self !== window.top ? "hidden" : ""),
                        onClick: ()=>router.back(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineArrowBackIos */.oTp, {}),
                            " Back to Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                        transparent: false
                    })
                ]
            })
        ]
    });
}
DonationPage.Layout = function Layout(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* UnauthenticatedWrapper */.j, {
        showFooter: false,
        children: children
    });
};


/***/ })

}]);